import { NgModule } from '@angular/core';
import { TrackerService } from './services/tracker.service';

@NgModule({ providers: [TrackerService] })
export class AnalyticsModule {}
